import React from 'react';
import { get } from 'lodash';

interface ICountRecord {
  count?: number;
  display_text?: string,
  _links?: object;
  badge_links?: object;
}

interface IProps {
  countRecord?: ICountRecord;
  rel: string;
  persist?: boolean;
}

function getLink(countRecord) {
  const link = get(countRecord, '_links.web.href');
  if (!link) { return undefined; }

  // Remove domain to preseve ORIGIN for admin.reverb.tools
  const loc = new URL(link);
  return loc.pathname + loc.search + loc.hash;
}

function ReverbHeaderUserBadge({
  rel,
  countRecord = {},
  persist,
}: IProps) {
  const hasCount = countRecord?.count > 0 || persist;
  const hasDisplayText = !!countRecord.display_text;

  if (hasCount && hasDisplayText) {
    return (
      <li>
        <a
          className="reverb-header__menu__link"
          href={getLink(countRecord)}
          rel={rel}
          data-notification-count={countRecord.count}
        >
          {countRecord.display_text}
        </a>
      </li>
    );
  }

  return null;
}

export default ReverbHeaderUserBadge;
